import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { SchedulePermission } from '../../schedules';
import { Toggle } from '../controls';
import { ModalLabel, PermissionLabel, PermissionRow } from './styles';

interface PermissionFieldProps {
  value: SchedulePermission;
  onChange: (value: SchedulePermission) => void;
  testId?: string;
}

/** Funcionamento ("Permitir refrigeração" / "Bloquear") dos modais de programação e de exceção. */
export function PermissionField({ value, onChange, testId }: Readonly<PermissionFieldProps>): ReactElement {
  const { t } = useTranslation();
  return (
    <>
      <ModalLabel as="div" style={{ marginTop: 22, marginBottom: 10 }}>{t('funcionamento')}</ModalLabel>
      <PermissionRow>
        <PermissionLabel $active={value === 'allow'}>{t('ecoSimplificadoPermitirRefrigeracao')}</PermissionLabel>
        <Toggle
          checked={value === 'allow'}
          onChange={(allow) => onChange(allow ? 'allow' : 'forbid')}
          label={t('funcionamento')}
          testId={testId}
        />
        <PermissionLabel $active={value === 'forbid'}>{t('ecoSimplificadoBloquear')}</PermissionLabel>
      </PermissionRow>
    </>
  );
}
